import {
  Button,
  ModalBody,
  ModalCloseButton,
  ModalFooter,
  ModalHeader,
  Stack,
  Text
} from '@homebotapp/hb-react-component-catalog'
import { CustomerProfileResponse } from './AddPreferredAgentModal'
import { defineMessages, useIntl } from 'react-intl'
import { PreferredPartnerCard } from '../../HomebotNetwork/PreferredPartnerCard'
import { formatCustomerProfileType } from '../../../../helpers/formatCustomerProfileType'

export const MSG = defineMessages({
  bodyFoundAgent: {
    id: 'ExistingAgentCard.bodyFoundAgent',
    defaultMessage: 'We found this {partnerType} in the Homebot Network.'
  },
  bodyAddAgent: {
    id: 'ExistingAgentCard.bodyAddAgent',
    defaultMessage: 'Adding a {partnerType} lets you reach them directly while exploring Homebot.'
  },
  heading: {
    id: 'ExistingAgentCard.heading',
    defaultMessage: 'Add {partnerType}'
  },
  cancel: {
    id: 'ExistingAgentCard.cancel',
    defaultMessage: 'No, cancel'
  },
  add: {
    id: 'ExistingAgentCard.add',
    defaultMessage: 'Yes, add existing'
  }
})

interface ExistingAgentViewProps {
  agent: CustomerProfileResponse
  isSubmitting: boolean
  onConfirm: () => Promise<void>
  onClose: () => void
  customerType?: 'RealEstateAgent' | 'LoanOfficer' | 'InsuranceAgent' | 'TitleAgent'
}

export const ExistingAgentCard = ({
  agent,
  isSubmitting,
  onConfirm,
  onClose,
  customerType = 'RealEstateAgent'
}: ExistingAgentViewProps) => {
  const intl = useIntl()
  const formattedCustomerType = formatCustomerProfileType(customerType).toLowerCase()

  return (
    <>
      <ModalHeader>
        <Text size='lg' fontWeight='semibold' color='neutral.900'>
          {intl.formatMessage(MSG.heading, { partnerType: formattedCustomerType })}
        </Text>
      </ModalHeader>
      <ModalCloseButton onClick={onClose} />

      <ModalBody pb={6}>
        <Text color='neutral.700' mb={4}>
          {intl.formatMessage(MSG.bodyFoundAgent, { partnerType: formattedCustomerType })}
        </Text>
        <Text size='lg' fontWeight='semibold' color='neutral.900' mb={4}>
          {intl.formatMessage(MSG.bodyAddAgent, { partnerType: formattedCustomerType })}
        </Text>
        <PreferredPartnerCard partner={agent} corporateProfile={agent.corporateProfile} />
      </ModalBody>

      <ModalFooter>
        <Stack direction='row' gap={2} justifyContent='flex-end'>
          <Button
            variant='ghost'
            onClick={onClose}
            tracking={{
              guid: 'r3MWAnn3B4itMFMh8RUzq6',
              ui_context: 'Existing agent card cancel',
              descriptor: 'Cancel add existing agent to team'
            }}
          >
            {intl.formatMessage(MSG.cancel)}
          </Button>
          <Button
            colorScheme='primary'
            onClick={onConfirm}
            isLoading={isSubmitting}
            tracking={{
              guid: 'w2KXKtnnhbBPqQMp1nRtVm',
              ui_context: 'Existing agent card confirm',
              descriptor: 'Add existing agent to team'
            }}
          >
            {intl.formatMessage(MSG.add)}
          </Button>
        </Stack>
      </ModalFooter>
    </>
  )
}
